import { projectRequest } from 'store/utils/request';

export const getUtterancesRequest = async intentId => {
  try {
    return await projectRequest.get(`/intents/${intentId}/ml-utterances/`);
  } catch (error) {
    throw error;
  }
};

export const addUtteranceRequest = async (intentId, data) => {
  try {
    return await projectRequest.post(
      `/intents/${intentId}/ml-utterances/`,
      data,
    );
  } catch (error) {
    throw error;
  }
};

export const updateUtteranceRequest = async (intentId, id, data) => {
  try {
    return await projectRequest.put(
      `/intents/${intentId}/ml-utterances/${id}/`,
      data,
    );
  } catch (error) {
    throw error;
  }
};

export const deleteUtteranceRequest = async (intentId, id) => {
  try {
    return await projectRequest.delete(
      `/intents/${intentId}/ml-utterances/${id}/`,
    );
  } catch (error) {
    throw error;
  }
};
